import React from "react";

interface IProductPositioningContext {
  index?: number;
  itemsPerRow?: number;
}

export const ProductPositioningContext =
  React.createContext<IProductPositioningContext>({});
